<template>
    <div>
        <template v-if="isTab">
            <b-tabs content-class="mt-3">
                <b-tab active>
                    <template #title>
                        <span class="mr-2">Packages Show for this product</span>
                        <span>
                            <b-badge style="font-size: 18px" variant="danger">{{packagesCustomTitle.length}}</b-badge>
                        </span>
                    </template>
                    <draggable v-model="packagesCustomTitle" group="packagesCustomTitle"
                               @update="updateOrderCustomTitle"
                               @start="drag=true"
                               handle=".handle"
                               @end="drag=false">
                        <div
                                v-for="(item,index) in packagesCustomTitle"
                                :key="index">
                            <Package :packageItem="item" :packages="packagesCustomTitle"
                                     :isServer="isServer"></Package>

                        </div>
                    </draggable>

                </b-tab>
                <!--END Main-->
                <b-tab>
                    <template #title>
                        <span class="mr-2">Packages Show in Category</span>
                        <span>
                            <b-badge style="font-size: 18px" variant="danger">{{packagesCategory.length}}</b-badge>
                        </span>
                    </template>
                    <draggable v-model="packagesCategory" group="packagesCategory"
                               @update="updateOrderCategory"
                               @start="drag=true"
                               handle=".handle"
                               @end="drag=false">
                        <div
                                v-for="(item,index) in packagesCategory"
                                :key="index">
                            <Package :packageItem="item" :packages="packagesCategory" :isServer="isServer"></Package>


                        </div>

                    </draggable>

                </b-tab>
                <!--END Offer-->
            </b-tabs>
        </template>

        <template v-else>
            <draggable v-model="packages" group="items"
                       @update="updateOrder"
                       @start="drag=true"
                       handle=".handle"
                       @end="drag=false">
                <div
                        v-for="(item,index) in packages"
                        :key="index"
                >
                    <Package :packageItem="item" :packages="packages" :isServer="isServer"></Package>

                </div>
            </draggable>

        </template>
    </div>
</template>

<script>

    import Package from './Package';
    import draggable from 'vuedraggable'
    import Http from '../../../Services/HttpService/HttpService'
    import Notificaion from '../../../Services/Notification/Nottification'


    export default {
        name: "Packages",
        components: {
            Package,
            draggable

        },
        props: {
            packages: {
                type: Array,
                default: null
            },
            packagesCustomTitle: {
                type: Array,
                default: null
            },
            packagesCategory: {
                type: Array,
                default: null
            },
            isServer: {
                type: Boolean,
                default: false
            },
            isTab: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {

            }
        },
        methods: {
            updateOrderCustomTitle() {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'product/package/order/items/process', {
                    items: this.packagesCustomTitle
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            //this.getItems();
                            Notificaion.success(response.data.message)
                        } else {
                            Notificaion.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            updateOrderCategory() {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'product/package/order/items/process', {
                    items: this.packagesCategory
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            //this.getItems();
                            Notificaion.success(response.data.message)
                        } else {
                            Notificaion.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
        },
        computed: {
            filterPackagesCustomTitles() {
                return this.packages.filter(item => {
                    return item.isCustomTitle.match('yes') || item.isCustomTitle.match(true);
                })
            },
            filterPackages() {
                return this.packages.filter(item => {
                    return item.isCustomTitle.match('no');
                })
            },

        }
    }
</script>

<style scoped>

</style>